// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ArticleSearch":"bat_a bho_ea bho_sn","ArticleSearch__items":"bat_b bho_tg","ArticleSearch__item":"bat_c bho_th"};